import React from 'react';
import {
  useAwaited,
  Outlet,
  useLoaderData,
} from '@tanstack/react-router';

import DashboardSidebarNavigation from '../components/Dashboard/SidebarNavigation';
import DashboardInvitationsBanner from '../components/Dashboard/InvitationsBanner';

import type { Stats } from '../types/stats';

import '@awesome.me/webawesome/dist/components/tooltip/tooltip.js';

const Dashboard: React.FC = () => {
  const { stats } = useLoaderData({ from: '/dashboard' });
  const statsData = useAwaited<Stats>({ promise: stats });
  const totalReceivedInvitations = statsData?.total_received_invitations || 0;

  return (
    <div className="container dashboard-container">
      <div className="wa-flank wa-flank:start wa-gap-0 wa-align-items-start" style={{ '--flank-size': '220px' } as React.CSSProperties}>
        <div className="wa-stack dashboard-sidebar wa-gap-0 inner wa-align-items-start">
          <DashboardSidebarNavigation stats={statsData} />
        </div>
        <div className="dashboard-main">
          <DashboardInvitationsBanner invitations={totalReceivedInvitations} />
          <div className="dashboard-main-content wa-stack wa-gap-0">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
